
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.031 4l.313 1.094S27 10.71 27 18.532c0 3.995-.921 6.637-2.344 8.281s-3.306 2.188-4.844 2.188c-1.728 0-3.206-.784-4.375-1.594s-2.165-1.731-2.344-1.844l1.063-1.688c.704.445 1.398 1.177 2.406 1.875S18.735 27 19.812 27c1.083 0 2.301-.33 3.313-1.5S25 22.218 25 18.531c0-6.501-1.022-10.659-1.344-11.875-3.442 1.276-7.451 1.856-10.688 3-1.789.632-3.284 1.437-4.313 2.563S6.999 14.796 6.999 17c0 1.938 1.058 3.143 2.219 3.969a7.84 7.84 0 001.625.875c1.72-2.744 4.356-6.157 8.438-10.531l1.438 1.375c-6.808 7.295-9.428 11.855-10.375 14.625-.473 1.385-.53 2.32-.5 3s.217 1.058.156 1.781l-2-.188c-.002.02-.116-.597-.156-1.5s.047-2.151.594-3.75c.303-.885.756-1.918 1.375-3.063a10.118 10.118 0 01-1.75-1C6.586 21.542 5 19.696 5 16.999c0-2.605.833-4.643 2.188-6.125s3.168-2.402 5.125-3.094c3.913-1.384 8.509-1.908 11.688-3.313z"}})])
          )
        }
      }
    